import { SectionHeader } from "./section-header"

const features = [
  { icon: "🎨", title: "Estímulos personalizados", desc: "Escolha os estímulos e associe cada um a uma resposta. Capture cores reais com a câmera quando o treino pedir." },
  { icon: "⚡", title: "Tempo de reação preciso", desc: "Medição em milissegundos. Nenhum cronômetro manual." },
  { icon: "📱", title: "QR Code para quem treina", desc: "Sem cadastro, sem app. Quem treina apenas escaneia o QR e a tela já está pronta." },
  { icon: "📊", title: "Histórico e evolução", desc: "Veja a evolução do tempo de reação por pessoa, por treino, por tipo de estímulo." },
  { icon: "🔴", title: "Color Dash", desc: "O primeiro drill da plataforma: estímulos em cores mapeados para movimentos físicos." },
  { icon: "☁️", title: "100% na web", desc: "Funciona em qualquer dispositivo com navegador. Sem instalação, sem atrito." },
]

export function Features() {
  return (
    <section id="funcionalidades" className="py-24 md:py-32 relative bg-card/20">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeader
          eyebrow="Funcionalidades"
          title={<>Tudo que você precisa para <span className="text-primary">treinar com inteligência</span></>}
        />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-2xl bg-card border border-white/5 p-7 hover:border-primary/40 hover:glow-primary-sm hover:-translate-y-1 transition-all"
            >
              <div className="h-12 w-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center text-2xl mb-5 group-hover:scale-110 transition-transform">
                {f.icon}
              </div>
              <h3 className="text-lg font-bold mb-2">{f.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
